export const SET_QUALITYCHECKTYPES = 'SET_QUALITYCHECKTYPES';
export const SET_QUALITYCHECKS = 'SET_QUALITYCHECKS';
export const SET_QUALITYCHECKORDERS = 'SET_QUALITYCHECKORDERS';


